import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id AED3CA58-6CAA-45AF-9791-F61AC32DAFBA
 * name bullet
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bullet.svg
 * tags
 */
export const BulletIcon = createSvgIcon(<><path d="M14,22H10V21H14V22M13,10V7H11V10L10,11.5V20H14V11.5L13,10M12,2C12,2 11,3 11,5V6H13V5C13,5 13,3 12,2Z" /></>, 'BulletIcon');
export default BulletIcon